<template>
  <div class="container-fluid nunav_login">

		<div class="row" style="margin-top: 15px;" v-if="isNuNavLogin">
		  <div class="col-12">
    		<img src="../../../assets/theme/common/img/precision_course_logo.png" style="width: 300px; height: auto; float: left; margin-left: 50px;" />
    	</div>
    </div>
    <div class="row top_bar" v-else>
      <div class="col-12">
        <div class="row header" style="margin-left: 30px;">
          <div class="col-3 logo_container">
            <img class="logo1" src="../../../assets/theme/default/img/pragyaLogo2020.svg" style="height: 90px; width: auto;" alt="Pragya Systems Logo">
          </div>
        </div>
      </div>
    </div>

    <div class="row user-login-section">
      <div class="col-12">

        <div class="row">
          <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 user-login-section-left">

              <div class="row" style="height: 100%;">
                <div class="col-12" style="height: 100%;">
              		<img class="img-login" src="../../../assets/theme/default/img/login.png" />
              	</div>

                <div class="col-12 pragya_book_logo">
                  <img src="../../../assets/theme/default/img/pragyaLogoOnlyBooks.svg" style="width: 150px; height: auto; float: left; margin-left: 70px;" />
                </div>
              </div>

          </div>

          <div class="col-xl-1 col-lg-1 col-md-1 col-sm-12 pg_col_sep"></div>

          <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 user-login-section-right" style="margin-top: 60px;">

              <div class="row">
                  <div class="col-xl-11 col-lg-11 col-md-12 col-sm-12 login-user-section login_sec_box" @keydown.enter="login">

                      <div class="row page_fld_section" style="margin-bottom: 10px;">
                          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                              <div class="landing-page-heading" v-if="isNuNavLogin">Log in to NuNav</div>
                              <div class="landing-page-heading" v-else>Log in</div>
                          </div>
                      </div>

                      <div class="row page_fld_section" style="height: 20px; margin-bottom: 10px;">
                          <div class="col-12" id="validation-message" style="display: none">
                              <div style="color: #ff0000; text-align: center;">{{errorMessage}}</div>
                          </div>
                      </div>

                      <div class="row page_fld_section" style="margin-bottom: 25px;">
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                              <div class="fld-label" id="eMail">Email</div>
                          </div>
                          <div class="col-xl-8 col-lg-9 col-md-9 col-sm-12">
                              <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                                  aria-labelledby="email" placeholder="Email" @blur.native="$v.eMail.$touch()"
                                  aria-describedby="eMailFeedback" style="height: 1.5em !important;" v-focus>
                              </b-form-input>
                              <b-form-invalid-feedback id="eMailFeedback">
                                  Please enter a proper email address.
                              </b-form-invalid-feedback>
                          </div>
                      </div>

                      <div class="row page_fld_section" style="margin-bottom: 25px;">
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                              <div class="fld-label" id="password">Password</div>
                          </div>
                          <div class="col-xl-8 col-lg-9 col-md-9 col-sm-12">
                              <b-form-input type="password" v-model.trim="password" :state="passwordState"
                                  aria-labelledby="password" placeholder="Password" @blur.native="$v.password.$touch()"
                                  aria-describedby="passwordFeedback" style="height: 1.5em !important;">
                              </b-form-input>
                              <b-form-invalid-feedback id="passwordFeedback">
                                 Password must not be empty.
                              </b-form-invalid-feedback>
                          </div>
                      </div>

                       <div class="row page_fld_section">
                          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                          	<span style="cursor: pointer; color: #157099;" @click="forgotPassword">Forgot Password?</span>
                          </div>
                          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                          	<b-button size="lg" @click="login" aria-label="login" style="float: right;">login</b-button>
                          </div>
                      </div>

                  </div>
              </div>

          </div>
        </div>

        <div class="footer-login row text-center">
          <div class="col-12">
            <div class="page-footer">
              <span> &copy; </span>
              <span v-if="isNuNavLogin">Copyright National University. All Rights Reserved.</span>
              <span v-else>2021 Pragya Systems Corp. All Rights Reserved.</span>
            </div>
          </div>
        </div>

  		</div>
    </div>


        <div>
            <b-modal v-model="showForgotPasswordModal" title="Forgot Password" :header-bg-variant="'warning'" :header-text-variant="'dark'" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered>
                <div class="text-center" @keydown.enter="resetPassword">
                    <template v-if="resetPasswordMessage">
                        <span style="color: Red;">{{resetPasswordMessage}}</span>
                    </template>
                    <template v-else>
                        <div class="float-left mr-3">
                            <div class="fld-label">User Email</div>
                        </div>
                        <div class="ml-5">
                            <b-form-input type="email" v-model.email="resetPasswordEmail" :state="resetPasswordEmailState"
                                aria-labelledby="reset email" placeholder="Email" @blur.native="$v.resetPasswordEmail.$touch()"
                                aria-describedby="resetPasswordEmailFeedback" style="height: 1.5em !important; width: 70%;">
                            </b-form-input>
                            <b-form-invalid-feedback id="resetPasswordEmailFeedback">
                                Please enter a proper email address.
                            </b-form-invalid-feedback>
                        </div>
                    </template>
                </div>
                <div slot="modal-footer" class="w-100">
                    <template v-if="resetPasswordMessage">
                        <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">ok</b-button>
                    </template>
                    <template v-else>
                        <b-button variant="primary" size="sm" class="float-right ml-3" @click="resetPassword">get new password</b-button>
                        <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">cancel</b-button>
                    </template>
                </div>
            </b-modal>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import {required, email} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)

  export default {
    name: 'nu-nav-login',
    data: () => {
      return {
        eMail: '',
        eMailState: null,
        password: '',
        passwordState: null,
        errorMessage: '',
        currentEnvironment: {},
        showForgotPasswordModal: false,
        resetPasswordEmail: '',
        resetPasswordEmailState: null,
        resetPasswordMessage: null,
        isNuNavLogin: (window.location.host.indexOf('nunav') !== -1)
      }
    },

    validations: {
      resetPasswordEmail: {
        required,
        email
      },
      eMail: {
        required,
        email
      },
      password: {
        required
      }
    },

    watch: {
      eMail (val) {
        if (val) {
          this.eMailState = true
        } else {
          this.eMailState = null
        }
      },

      password (val) {
        if (val) {
          this.passwordState = true
        } else {
          this.passwordState = null
        }
      },

      resetPasswordEmail (val) {
        if (val) {
          this.resetPasswordEmailState = true
        } else {
          this.resetPasswordEmailState = null
        }
      }
    },

    mounted () {
      this.getEnvironment()
    },

    methods: {
      ...mapActions([
        'loadResetPassword',
        'loadEnvironment',
        'loadLoginUser',
        'setUserInfo'
      ]),

      getEnvironment () {
        if (!this.$parent.isSessionExpired()) {
          let path = this.$router.currentRoute.path
          if (path === '/login') {
            let role = localStorage.getItem('userrole')
            if (role === 'SuperAdmin') {
              window.location.href = '/dashboard/views/usersList.html'
            } else {
              this.$store.commit('LOAD_USER_ROLE', role)
              this.navigateToDashboard(role)
            }
          }
        } else {
          this.loadEnvironment().then(res => {
            if (res && res.status !== 503) {
              this.currentEnvironment = res.data
              this.$root.$emit('serviceAvailable', true)
            } else {
              let errorThrown = res.statusText
              this.$root.$emit('serviceAvailable', false, errorThrown)
            }
          })
        }
      },

      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },

      forgotPassword () {
        this.resetPasswordEmail = ''
        this.resetPasswordMessage = null
        this.resetPasswordEmailState = null
        this.showForgotPasswordModal = true
        this.$v.resetPasswordEmail.$touch()
      },

      resetPassword () {
        this.$v.resetPasswordEmail.$touch()
        if (this.$v.resetPasswordEmail.$error) {
          this.resetPasswordEmailState = false
        }
        if (this.resetPasswordEmailState) {
          this.loadResetPassword(this.resetPasswordEmail).then(res => {
            if (res.status === 401) {
              this.resetPasswordMessage = 'This email "' + this.resetPasswordEmail + '" does not exist.'
            } else if (res.status === 500) {
              this.resetPasswordMessage = 'Error in service call.'
            } else {
              this.resetPasswordMessage = 'Please check your registered email for password reset instructions.'
            }
          })
        }
      },

      login () {
        this.$v.eMail.$touch()
        this.$v.password.$touch()
        if (this.$v.eMail.$error) {
          this.eMailState = false
        }
        if (this.$v.password.$error) {
          this.passwordState = false
        }
        if (this.eMailState && this.passwordState) {
          this.showLoader()
          let href = window.location.href.split('?')
          let paramValues = []
          if (href.length > 1) {
            let paramsString = href[1]
            paramValues = paramsString.split('=')
          }
          this.loadLoginUser({eMail: this.eMail, password: this.password}).then(res => {
            this.$store.commit('LOAD_ALL_CHANNELS', [])
            this.$store.commit('LOAD_LEARNING_SPACES', [])
            let status = res.status
            let userObj = res.data
            if (status === 200) {
              if (!this.validateTnC(userObj)) {
                if (!paramValues.length > 1) {
                  return this.$router.push({name: 'termsAndConditions', params: {userObj: userObj}, query: {redirect: paramValues[1]}})
                } else {
                  return this.$router.push({name: 'termsAndConditions', params: {userObj: userObj}})
                }
              } else {
                $('#launcher').show()
                this.setUserInfo(userObj)
                let role = userObj.roles[0].role
                if (role === 'SuperAdmin') {
                  return this.$router.push({ name: 'superAdminDashboard' })
                } else {
                  this.navigateToDashboard(role)
                }
              }
            } else {
              this.hideLoader()
              switch (status) {
                case 503:
                  this.errorMessage = 'Server temporarily unavailable'
                  break
                case 401:
                  this.errorMessage = 'Invalid email or password'
                  break
                case 400:
                  this.errorMessage = 'Please enter all required fields'
                  break
                default:
                  this.errorMessage = 'Unexpected error code: ' + status
                  break
              }
              $('#validation-message').fadeIn('fast').delay(2000).fadeOut('slow')
            }
          })
        }
      },

      validateTnC (userObj) {
        let permission = userObj.permission
        if (!permission.institutionPermission.create && !userObj.tnCAccepted) {
          return false
        }
        return true
      },

      navigateToDashboard (userRole) {
        this.$parent.isUserLoggedIn = true
        this.$parent.isServiceAvailable = true
        let role = userRole.toLowerCase()
        let url = '/user/track/' + role
        if ((role === 'instructor & admin') || (role === 'curator')) {
          url = '/user/track/admin'
        } else if (role === 'employer admin') {
          url = '/employer/admin'
        } else if (role === 'prospective student' || role === 'admitted student' || role === 'widget admin') {
          url = '/user/track/' + role.split(' ').join('_')
        }
        return this.$router.push(url)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/login/components/NuNavLogin.vue